/**
 * @generated SignedSource<<49d5a5260065131a3efe3ebdbf6970ca>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRefineMenuInputRangeDimensions_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuDimensionUnitRadioSelect_user" | "SbSharedRefineMenuFilterTableSize_user" | "useMeasurementUnit_user">;
  readonly " $fragmentType": "SbSharedRefineMenuInputRangeDimensions_user";
};
export type SbSharedRefineMenuInputRangeDimensions_user$key = {
  readonly " $data"?: SbSharedRefineMenuInputRangeDimensions_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRefineMenuInputRangeDimensions_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRefineMenuInputRangeDimensions_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useMeasurementUnit_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuDimensionUnitRadioSelect_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbSharedRefineMenuFilterTableSize_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "602f5fcbe5674de409f20f8f6d90f58e";

export default node;
